import {
  DoubleSide,
  ShaderMaterial
} from 'three';

export const createRightMaterial = () => {
  return new ShaderMaterial({
    uniforms: {
      offsetX: { value: .5 },
      offsetY: { value: 0.0 },
      scaleX: { value: .5 },
      scaleY: { value: 1.0 },
      tex: {
        value: null
      },
      ratio: {
        value: 0
      },
      isPortrait: {
        value: false
      }
    },
    side: DoubleSide,
    transparent: true,
    depthWrite: true,
    depthTest: true,
    vertexShader: RightMterialProps.vertexShader,
    fragmentShader: RightMterialProps.fragmentShader,
  });
}

export const RightMterialProps = {
  vertexShader:
    `
  varying vec2 vUv;
  uniform float offsetX;
  uniform float offsetY;
  uniform float scaleX;
  uniform float scaleY;

  void main() {
  vUv = uv * vec2(scaleX, scaleY) + vec2(offsetX, offsetY);
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  }
`,
  fragmentShader: `
        uniform sampler2D tex;
        varying vec2 vUv;
        void main() {
            vec2 uv = vUv - vec2(0.5, 0.5);
            uv.y *=.5;
            vec4 texel = texture2D( tex, uv + vec2(0.5, 0.5) );
            gl_FragColor = texel;
        }
    `
}


